$(document).ready(function(){
  $("input#search-drawer-query-input").on('click',function(){
    $('.quick-data-1').slick({
      centerMode: false,
      slidesToShow: 3,
      infinite: false,
      slidesToScroll: 3,
      arrows: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
          {
          breakpoint: 540,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  });
  
  $("body").on("click",function(e){    
    $('button.input-group-append.yv-search-drawer-close').hide();
    $('.header-search').removeClass('search-block');
  });
  $(".input-with-icon").on("click",function(e){
    e.stopPropagation();
  });
  $('.mega-menu-text').click(function(event) {
    event.stopPropagation();
  });
  $("ul#myid").click(function (event) {
    event.preventDefault();
  });

   $("button.input-group-append.yv-search-drawer-close").click(function(){
      $("button.input-group-append.yv-search-drawer-close").css("display", "none");
  });
   $(".input-with-icon").click(function(e){
      $('.header-search').addClass('search-block');    
  });




/**Search Functionality Custom**/
  function productclick(){
    $('#filter-products a').click(function(e){
      e.preventDefault();
      alert('tvfhb');
      var title = $(this).parents('.yv-product-card').attr('data-title');
      if (Cookies.get("search_cookie") === undefined ){
         var abc = title;
         Cookies.set("search_cookie", abc);
      }else{
        var oldresult = Cookies.get("search_cookie");  
        var exists = false;
        var forcompare = oldresult.split('~@~');
        for(var i = 0; i < forcompare.length; i++) {
            if(forcompare[i] == title){
              exists = true;
            }
        }
        if(exists == false){
          var abc = oldresult+'~@~'+title;
          Cookies.set("search_cookie", abc);
        }
      }
      return;
    });
  }
  
  
  function commontg(){
     $(".recent-result .result-clear").on("click",function() {
       var attr_name = $(this).closest(".serach-headings").attr("data-attr");
       $(".recent-result .serach-headings[data-attr='"+attr_name+"']").remove();
       var prevdata = Cookies.get("search_cookie");
       newdata = prevdata.replace(attr_name, '');
       if(newdata.indexOf('~@~~@~') > -1 ){
         newdata = newdata.replace('~@~~@~', '~@~')
       }
       if(newdata.indexOf('~@~') > -1){
         var newdatalength = newdata.split('~@~');
         var last = newdatalength.length - 1;
  
         if(newdatalength[last] == ""){ 
           newdata = newdata.slice(0, -3);
         }
         if(newdatalength[0] == ""){ 
           newdata = newdata.slice(3);
         }
       }
       Cookies.set("search_cookie", newdata);
       
       if( newdata == ''){
         $('.recent-result').hide();
         Cookies.remove('search_cookie');
       }
       $("#search-drawer-query-input").val("");
     });
     $('.serach-headings').on("click",function() {
        var value = $(this).find(".name-field").text();   
        var input = $('#search-drawer-query-input');
        input.val(value);
        $('.search-icon-btn').trigger('click');
        return false;
     })
  
     $('.idmy li').click(function(e){
        var featuredlink = $(this).text();
       if (Cookies.get("search_cookie") === undefined ){
         var abc = featuredlink;
         Cookies.set("search_cookie", abc);
       }else{
          var oldresult = Cookies.get("search_cookie");  
          var exists = false;
          var forcompare = oldresult.split('~@~');
          for(var i = 0; i < forcompare.length; i++) {
              if(forcompare[i] == featuredlink){
                exists = true;
              }
          }
          if(exists == false){
            var abc = oldresult+'~@~'+featuredlink;
            Cookies.set("search_cookie", abc);
          }
       }
        var input = $('#search-drawer-query-input');
        input.val(featuredlink);
        $('.search-icon-btn').trigger('click');
    });
    
    productclick();

    $("input#search-drawer-query-input").on('input',function(){
      if ( $("#search-drawer-query-input").val() == ""){
        $('.mega').removeClass('search-display');    
        $("button.input-group-append.yv-search-drawer-close").css("display", "none");
      }else {
        // var inputval =  $("input#search-drawer-query-input").val();
        // if(data_1.length >= 3){
          
        // }
         
        $('.mega').addClass('search-display');    
        $("button.input-group-append.yv-search-drawer-close").css("display", "block");
        setTimeout(function() {
          productclick();
        }, 1000)
      }
    });
  }

  var closebtn='<div class="result-clear"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="#000"><path d="M16 17a1 1 0 01-.71-.29l-8-8a1 1 0 111.42-1.42l8 8a1 1 0 010 1.42A1 1 0 0116 17z"></path><path d="M8 17a1 1 0 01-.71-.29 1 1 0 010-1.42l8-8a1 1 0 111.42 1.42l-8 8A1 1 0 018 17z"></path></g></svg></div>';
  function checker(){
     if (Cookies.get("search_cookie") === undefined ){
       commontg();
     }else{
       var oldresult = Cookies.get("search_cookie");
       var newestcookie = oldresult;
       if(oldresult != ''){
         var enterdata = '';
         if(oldresult.indexOf('~@~') > -1){
           var oldresultlength = oldresult.split('~@~');
           var eachdata = '';
           for(var i = oldresultlength.length-1; i >=0; i--) {
              eachdata+= '<div class="serach-headings" data-attr="'+oldresultlength[i]+'">'+ '<div class="name-field">'+oldresultlength[i]+ '</div>'+ closebtn +'</div>';
           }
           enterdata = eachdata;
         }else{
           enterdata = '<div class="serach-headings" data-attr="'+oldresult+'">'+ '<div class="name-field">'+oldresult+ '</div>'+ closebtn +'</div>';
         }
         if(enterdata != ''){
           Cookies.set("search_cookie", newestcookie);
           $('.recent-result').append('<h6>Recent Searches</h6><div class="search-result-outer">'+enterdata+'</div>');
         }else{
           $('.recent-result').hide();
           Cookies.remove('search_cookie');
         }
       }
        commontg();
     }
  }

  checker();
  
  $('input.search-input').on("keypress",function(e){
    if(e.which == 13) {
       var data_1 = $('input#search-drawer-query-input').val();
       $('.recent-result').hide();
       var dataq = '';
       var closebtn='<div class="result-clear">X</div>';
     
       if (Cookies.get("search_cookie") === undefined){
         if(data_1 != ''){
           datahtml = '<div class="serach-headings" data-attr="'+data_1+'">'+ '<div class="name-field">'+data_1+ '</div>'+ closebtn +'</div>';
           dataq = data_1;  
         }
       }else{
        if(data_1 == ''){
            var oldresult = Cookies.get("search_cookie");  
            dataq = oldresult;
        }else{
          var oldresult = Cookies.get("search_cookie");  
          var forcompare = oldresult.split('~@~');
          var exists = false;
           for(var i = 0; i < forcompare.length; i++) {
              if(forcompare[i] == data_1){
                exists = true;
              }
           }
          if(exists == false){
            dataq = oldresult+'~@~'+data_1;
          }
        }
         
        var enterdata = '';
        if(dataq.indexOf('~@~') > -1){
           var dataqlength = dataq.split('~@~');
           var eachdata = '';
    
           for(var i = dataqlength.length-1; i >= 0; i--) {
              eachdata+= '<div class="serach-headings" data-attr="'+dataqlength[i]+'">'+ '<div class="name-field">'+dataqlength[i]+ '</div>'+ closebtn +'</div>';
           }
           enterdata = eachdata;
         }else{
           enterdata = '<div class="serach-headings" data-attr="'+dataq+'">'+ '<div class="name-field">'+dataq+ '</div>'+ closebtn +'</div>';
         }
         datahtml = enterdata;
       }
      
    //   checker();
      if(dataq != ''){
       Cookies.set("search_cookie", dataq);
       $('.recent-result').append('<h6>Recent Searches</h6><div class="search-result-outer">'+datahtml+'</div>');      
      }else{
        $('.recent-result').hide();
        Cookies.remove('search_cookie');
      } 
      commontg();
    } 
  });
});
